import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "truncate max-w-fit" }
const _hoisted_5 = { class: "text-gray-400" }
const _hoisted_6 = { class: "flex justify-end gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-end gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "col-span-12 md:col-span-3 motion-safe:animate-fadeIn group bg-white !rounded-2xl !shadow-md hover:!shadow-xl transition-all duration-200 overflow-hidden cursor-default" }, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.course?.file?.url || _ctx.emptyImg,
          onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imgDefaultError && _ctx.imgDefaultError(...args))),
          class: "w-full h-48 object-cover transform group-hover:scale-105 transition-transform duration-200",
          style: {"height":"13rem"},
          loading: "lazy"
        }, null, 40, _hoisted_2),
        (_ctx.stats === false)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(`${_ctx.utils.getStatusColor(
            _ctx.course?.status!
          )} absolute top-4 right-4 px-2 py-1 text-xs rounded-full font-bold shadow-md`)
            }, _toDisplayString(_ctx.utils.getStatus(_ctx.course?.status!)), 3))
          : _createCommentVNode("", true)
      ])
    ]),
    title: _withCtx(() => [
      _createElementVNode("div", {
        class: "flex text-h-primary-500 justify-between items-center hover:cursor-pointer hover:text-h-secondary-600",
        title: _ctx.course?.name,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onEdit(_ctx.course)))
      }, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.course?.name), 1),
        (_ctx.stats === false)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              name: `${
            _ctx.user.role == 'TEACHER' ? 'hi-solid-pencil' : 'hi-solid-eye'
          }`,
              class: "text-h-primary-500 cursor-pointer hover:scale-125",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onEdit(_ctx.course)))
            }, null, 8, ["name"]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_3)
    ]),
    _: 2
  }, [
    (_ctx.stats === false)
      ? {
          name: "subtitle",
          fn: _withCtx(() => [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", { pt: "Duração: ", en: "Duration: " })) + " " + _toDisplayString(_ctx.generics.getDurationTime(_ctx.course?.duration!)), 1)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.stats)
      ? {
          name: "content",
          fn: _withCtx(() => []),
          key: "1"
        }
      : {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("p", { class: "line-clamp-2 text-gray-600" }, _toDisplayString(_ctx.course?.description), 1)
          ]),
          key: "2"
        },
    (_ctx.course?.status !== 'PUBLISHED' && _ctx.stats === false)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.course?.status == 'REPROVED' && _ctx.user.role == 'TEACHER')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_Button, {
                      label: _ctx.$t('labels.generic', { pt: 'Ver mais', en: 'More' }),
                      class: "btn-outline p-button-sm",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSeeMore(_ctx.course)))
                    }, null, 8, ["label"]),
                    _createVNode(_component_Button, {
                      label: 
              _ctx.$t('labels.generic', { pt: 'Enviar novamente', en: 'Send again' })
            ,
                      class: "btn-primary p-button-sm",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSendToApprove(_ctx.course)))
                    }, null, 8, ["label"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.course?.status == 'APPROVED')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: _ctx.$t('labels.generic', { pt: 'Publicar', en: 'Publish' }),
                    class: "btn-primary p-button-sm",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPublish(_ctx.course)))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.course?.status == 'NOT_PUBLISHED' && _ctx.user.role == 'TEACHER')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    label: 
            _ctx.$t('labels.generic', {
              pt: 'Enviar para aprovação',
              en: 'Send to approve',
            })
          ,
                    class: "btn-outline p-button-sm",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSendToApprove(_ctx.course)))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.course?.status == 'WAITING' && _ctx.user.role == 'ADMINISTRATOR')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 3,
                    label: 
            _ctx.$t('labels.generic', {
              pt: 'Reprovar',
              en: 'To reprove',
            })
          ,
                    class: "btn-outline p-button-sm",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onReprove(_ctx.course)))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.course?.status == 'WAITING' && _ctx.user.role == 'ADMINISTRATOR')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 4,
                    label: 
            _ctx.$t('labels.generic', {
              pt: 'Aprovar',
              en: 'To approve',
            })
          ,
                    class: "btn-primary p-button-sm",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onApprove(_ctx.course)))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true)
            ])
          ]),
          key: "3"
        }
      : undefined
  ]), 1024))
}